import React, {useContext, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from 'react-router-dom';
import {TranslateContext} from "../../../context/TranslateContext";
import {AuthContext} from "../../../context/AuthContext";
import {KpiContext} from "../../../context/KpiContext";
import {AlertMsgContext} from "../../../context/AlertMsgContext";
import {
    aggiornaStatoValoriKpiApi,
    aggiornaValoriTabellaKpiAndTipoApi,
    aggiungiValoriTabellaKpiApi,
    getKpiByIdAndTipoApi, getStrutturaKpiApi
} from "../services/KpiServices";
import ModificaDatiKpiView from "./ModificaDatiKpiView";

export default function ModificaDatiKpiController() {
    const {id, idTipoImport} = useParams();

    const [kpi, setKpi] = useState();
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [strutturaKpi, setStrutturaKpi] = useState([]);
    const [nuovoStato, setNuovoStato] = useState('');
    const [daSalvare, setDaSalvare] = useState(false);

    const formikRef = useRef();
    const {translate, lingua, loadingNewLang} = useContext(TranslateContext);
    const {annoKpi} = useContext(AuthContext);
    const {resetIdFieldKpiFocus} = useContext(KpiContext);
    const {showSuccessMessage, showInfoMessage} = useContext(AlertMsgContext);
    const history = useHistory();

    async function getKpi() {
        const response = await getKpiByIdAndTipoApi(id, idTipoImport);
        setKpi(response.data.data);
        setNuovoStato(response.data.data.id_stato_kpi);
    }

    async function getStrutturaKpi() {
        const response = await getStrutturaKpiApi(id, `?val=1&id_tipo_imp_dati=${idTipoImport}`)
        setStrutturaKpi(response.data.data);
    }

    async function updateStrutturaKpi(strutturaNew) {
        setStrutturaKpi(strutturaNew);
    }

    useEffect(() => {
        if (loadingNewLang === false) {
            if (id && id !== '' && id !== null && idTipoImport && idTipoImport !== '') {
                getKpi();
                getStrutturaKpi();
                resetIdFieldKpiFocus();
            } else {
                setKpi(null);
                setStrutturaKpi(null);
            }
        }
    }, [lingua, loadingNewLang, id, annoKpi, idTipoImport]);

    const salvaValoriKpi = async () => {
        const response = await aggiungiValoriTabellaKpiApi(id, idTipoImport, strutturaKpi)
        if (response.data.result === 0) {
            showSuccessMessage(translate("Salvataggio avvenuto con successo"));
            setStrutturaKpi(response.data.data);
            setDaSalvare(false);

            // Scarico anche il KPI con gli stati dipendenti
            getKpi();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiornaValoriTabellaKpi(tabella) {
        const response = await aggiornaValoriTabellaKpiAndTipoApi(id, idTipoImport, tabella)
        if (response.data.result === 0) {
            setStrutturaKpi(response.data.data);
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    async function aggiornaStatoKpi() {
        let stato = {
            id_kpi: id,
            id_tipo_imp_dati: kpi.id_tipo_imp_dati,
            id_stato_kpi: nuovoStato
        };
        const response = await aggiornaStatoValoriKpiApi(id, stato);
        if (response.data.result === 0) {
            setKpi(response.data.data);
            showSuccessMessage(response.data.description);
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    }

    const bottoniSx = [
        {
            icon: 'fas fa-angle-left',
            command: () => {
                history.goBack();
            }
        }
    ];

    const bottoniDx = [
        {
            label: translate("Salva"),
            icon: "fas fa-save",
            command: salvaValoriKpi
        }
    ];

    function handleChangeKpi(tabella) {
        setDaSalvare(true);
        aggiornaValoriTabellaKpi(tabella);
    }

    return kpi && (
        <ModificaDatiKpiView
            strutturaKpi={strutturaKpi}
            updateStrutturaKpi={updateStrutturaKpi}
            translate={translate}
            kpi={kpi}
            modalMsg={modalMsg}
            show={show}
            setShow={setShow}
            formikRef={formikRef}
            aggiornaStatoKpi={aggiornaStatoKpi}
            daSalvare={daSalvare}
            nuovoStato={nuovoStato}
            setNuovoStato={setNuovoStato}
            showInfoMessage={showInfoMessage}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
            handleChangeKpi={handleChangeKpi}
        />
    );
}